import { NgIf, NgTemplateOutlet } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Tooltip, TooltipOptions } from '@com-delta-omnichannel/mach-core-js';
import { BookWidgetFieldInfoModal } from '../../../../models/book-widget-aem.interfaces';
import { generateRandomIdString } from '../mach-core-utils';

@Component({
  standalone: true,
  selector: 'idp-info-tooltip-mach-core',
  templateUrl: './info-tooltip-mach-core.component.html',
  styleUrls: ['./info-tooltip-mach-core.component.scss'],
  imports: [NgTemplateOutlet, NgIf]
})
export class InfoTooltipMachCoreComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private tooltip!: Tooltip;
  private readonly TOOLTIP_DEFAULTS = {
    positions: 'bottom-left' as const,
    color: 'high-contrast' as const,
    triggerEvent: 'hover' as const,
    offset: 0,
    showTip: true,
    showBorder: true,
    closeOnScroll: false,
    delayDuration: 0
  };

  @Input() infoModalContent!: BookWidgetFieldInfoModal;
  @Input() triggerIcon =
    '/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg';

  @Input() tooltipOptions!: LimitedTooltipOptions;

  protected tooltipElementId = '';
  protected tooltipTriggerElementId = '';

  ngOnInit() {
    this.tooltipElementId = this.createElementId('tooltip');
    this.tooltipTriggerElementId = this.createElementId('trigger');
  }

  ngAfterViewInit(): void {
    this.initializeTooltip();
  }

  protected initializeTooltip() {
    this.tooltip = new Tooltip({
      id: this.tooltipElementId,
      positionElement: this.tooltipTriggerElementId,
      ...this.TOOLTIP_DEFAULTS,
      ...this.tooltipOptions
    });
  }

  protected handleTooltipCloseIconClick() {
    this.tooltip.close();
  }

  private createElementId(element: 'tooltip' | 'trigger') {
    return `${element}-${generateRandomIdString()}`;
  }

  ngOnDestroy(): void {
    if (this.tooltip) {
      this.tooltip.destroy();
    }
  }
}

export type LimitedTooltipOptions = Omit<
  TooltipOptions,
  'id' | 'positionElement'
>;
